;(function () {
  'use strict';

  let angular = window.angular;

  TelegramChatFormController.$inject = [
    'Customer',
    'AppUtils'
  ];

  angular
    .module('app')
    .component('connectionTelegramChatRemove', {
      template:'<div ng-class="{transparent: ctrl.loading}"><div class="modal-header"><span translate>buttons.delete</span> <span translate>entities.telegramchat.modelName</span></div><div class="modal-body text-center"><div translate data-translate-values="{model: \'entities.telegramchat.modelName\', name: ctrl.telegramChat.name}">general._messages.remove</div></div><div ng-if="ctrl.removeTelegramChatError" class="alert alert-warning text-center marginB0 marginT10">{{ctrl.removeTelegramChatError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" type="button" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-danger" type="button" ng-click="ctrl.removeTelegramChat()" translate>buttons.delete</button></div></div><spinner css-class="\'small\'" show-logo="true" show="ctrl.loading"></spinner>',
      controller: TelegramChatFormController,
      controllerAs: 'ctrl',
      bindings: {
        modalInstance: '<',
        resolve: '<'
      }
    });

  function TelegramChatFormController (Customer, utils) {
    let vm = this;

    vm.$onInit = function onInit () {
      vm.telegramChat = vm.resolve.telegramChat;
      vm.customer = vm.resolve.customer;
      vm.removeTelegramChat = removeTelegramChat;
    };

    function removeTelegramChat () {
      if (!vm.telegramChat) {
        return;
      }

      vm.loading = true;
      Customer.telegramChats
        .destroyById({
          id: vm.customer.id,
          fk: vm.telegramChat.id
        })
        .$promise
        .then(() => {
          vm.loading = false;
          vm.modalInstance.close();
        })
        .catch(err => {
          vm.loading = false;
          vm.removeTelegramChatError = utils.getHTTPError(err);
        });
    }
  }
})();
